import React from "react";
import { MapPin, Truck } from "lucide-react";

const Hero: React.FC = () => {
  return (
    <>
      <link rel="preload" as="image" href="/Estef Cakesdsds.png" />
      <section
        id="home"
        className="relative flex items-center overflow-hidden"
        style={{
          minHeight: "88vh",
          background:
            "linear-gradient(135deg, #fff1f2 0%, #fce7f3 45%, #fdf8f0 75%, #fff1f2 100%)",
        }}
      >
        {/* Decorative blobs */}
        <div
          className="absolute top-16 right-8 w-64 h-64 rounded-full opacity-25 blur-3xl pointer-events-none"
          style={{ background: "radial-gradient(circle, #fb7185, #f9a8d4)" }}
        />
        <div
          className="absolute bottom-16 left-8 w-56 h-56 rounded-full opacity-15 blur-3xl pointer-events-none"
          style={{ background: "radial-gradient(circle, #fda4af, #fce7f3)" }}
        />

        <div className="max-w-5xl mx-auto px-5 sm:px-8 pt-24 pb-16 md:pt-28 md:pb-20 relative z-10 w-full">
          <div className="flex flex-col items-center text-center">

            {/* Logo */}
            <div className="mb-5 md:mb-6">
              <img
                src="/Estef Cakesdsds.png"
                alt="Estef's Cakes"
                loading="eager"
                decoding="async"
                width={1684}
                height={1340}
                className="w-full max-w-xs md:max-w-sm h-auto mx-auto drop-shadow-md"
                style={{
                  aspectRatio: "1684 / 1340",
                  animation: "float 4s ease-in-out infinite",
                }}
              />
            </div>


            {/* Headline */}
            <p className="font-body text-rose-700/80 text-base md:text-lg mb-7 max-w-xl leading-relaxed">
              Endulzamos tus celebraciones con tortas hechas a mano, con amor y
              los mejores ingredientes para que cada momento sea{" "}
              <em className="text-rose-600 not-italic font-semibold">inolvidable</em>.
            </p>

            {/* Pills */}
            <div className="flex flex-wrap gap-2.5 justify-center mb-8">
              <div className="flex items-center gap-1.5 bg-white/80 border border-rose-100 rounded-full px-3.5 py-1.5 shadow-sm">
                <MapPin className="w-3.5 h-3.5 text-rose-500" />
                <span className="font-body text-xs text-rose-700">Puerto La Cruz</span>
              </div>
              <div className="flex items-center gap-1.5 bg-white/80 border border-rose-100 rounded-full px-3.5 py-1.5 shadow-sm">
                <Truck className="w-3.5 h-3.5 text-rose-500" />
                <span className="font-body text-xs text-rose-700">Delivery disponible</span>
              </div>
            </div>

            {/* CTAs */}
            <div className="flex flex-col sm:flex-row gap-3 w-full max-w-sm sm:max-w-none sm:justify-center">
              <a
                href="#catalogo"
                onClick={(e) => {
                  e.preventDefault();
                  window.history.replaceState(null, "", "#catalogo");
                  window.dispatchEvent(new HashChangeEvent("hashchange"));
                  document.getElementById("hub")?.scrollIntoView({ behavior: "smooth" });
                }}
                className="inline-flex items-center justify-center gap-2 bg-rose-700 hover:bg-rose-800 active:scale-95 text-white font-semibold px-7 py-3.5 rounded-full transition-all duration-200 shadow-lg shadow-rose-200/60 hover:shadow-xl hover:-translate-y-0.5 text-sm w-full sm:w-auto"
              >
                <ShoppingBagIcon />
                Ver catálogo
              </a>
              <a
                href="#personalizar"
                onClick={(e) => {
                  e.preventDefault();
                  window.history.replaceState(null, "", "#personalizar");
                  window.dispatchEvent(new HashChangeEvent("hashchange"));
                  const customCakesEl = document.getElementById("custom-cakes");
                  if (customCakesEl) {
                    const yOffset = -70;
                    const y = customCakesEl.getBoundingClientRect().top + window.pageYOffset + yOffset;
                    window.scrollTo({ top: y, behavior: "smooth" });
                  } else {
                    document.getElementById("hub")?.scrollIntoView({ behavior: "smooth" });
                  }
                }}
                className="inline-flex items-center justify-center gap-2 bg-white hover:bg-rose-50 active:scale-95 text-rose-700 border border-rose-300 hover:border-rose-400 font-semibold px-7 py-3.5 rounded-full transition-all duration-200 shadow-sm hover:shadow-md hover:-translate-y-0.5 text-sm w-full sm:w-auto"
              >
                <CustomIcon />
                Personaliza tu torta
              </a>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

function ShoppingBagIcon() {
  return (
    <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
      <path strokeLinecap="round" strokeLinejoin="round" d="M16 11V7a4 4 0 00-8 0v4M5 9h14l1 12H4L5 9z" />
    </svg>
  );
}

function CustomIcon() {
  return (
    <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
      <path strokeLinecap="round" strokeLinejoin="round" d="M20 21v-8a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v8" />
      <path strokeLinecap="round" strokeLinejoin="round" d="M4 16s.5-1 2-1 2.5 2 4 2 2.5-2 4-2 2.5 2 4 2 2 1 2 1" />
      <path strokeLinecap="round" strokeLinejoin="round" d="M2 21h20" />
    </svg>
  );
}

export default Hero;
